export default {
    error: {
        message: null,
        status: null,
    },
};
